export enum PreferenceType {
  CompanyPreference = 'COMPANY_PREFERENCE',
  GroupPreference = 'GROUP_PREFERENCE',
  UserPreference = 'USER_PREFERENCE',
  CustomerPreferenceTemplate = 'CUSTOMER_PREFERENCE_TEMPLATE',
}
